var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-item"},[_c('v-icon',{staticClass:"me-2",attrs:{"size":"16"}},[_vm._v("fas fa-file")]),_c('b',{staticClass:"file-name"},[_vm._v(_vm._s(_vm.file.name))]),_c('button',{staticClass:"view-btn",on:{"click":_vm.viewFile}},[_c('v-icon',{staticClass:"ma-1",attrs:{"size":"16","color":"primary"}},[_vm._v("fas fa-eye")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }